// src/components/Header.jsx
import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/logo.png";

function Header() {
  return (
    <header style={{ width: "100%", background: "#1f4e3d", color: "#fff", fontFamily: "Inter, sans-serif" }}>
    <div style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "0 60px",
      height: "160px", // 🔼 header yüksekliği artırıldı
      background: "#1f4e3d"
    }}>
    
      {/* Logo ve isim */}
      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        <img src={logo} alt="Minhal Turizm Logo" style={{ height: "160px" }} /> {/* 🔼 logo büyütüldü */}
        <span style={{
          fontSize: "32px",
          fontWeight: 500,
          fontFamily: "'Cormorant Garamond', serif",
          letterSpacing: "1px",
          color: "#fff"
        }}>
          MİNHALTURİZM
        </span>
      </div>
  
  
      {/* Menü */}
      <nav>
        <ul style={{
          display: "flex",
          gap: "40px",
          listStyle: "none",
          margin: 0,
          padding: 0,
          fontWeight: "500"
        }}>
          <li><Link to="/hac" style={menuLink}>Hac <span style={downIcon}>▼</span></Link></li>
          <li><Link to="/umre" style={menuLink}>Umre <span style={downIcon}>▼</span></Link></li>
          <li><Link to="/kultur-turlari" style={menuLink}>Kültür Turları</Link></li>
          <li><Link to="/ucak-bileti" style={menuLink}>Uçak Bileti</Link></li>
          <li><Link to="/odeme" style={menuLink}>Ödeme <span style={downIcon}>▼</span></Link></li>
          <li><Link to="/iletisim" style={menuLink}>İletişim</Link></li>
        </ul>
      </nav>
    </div>
  </header>
  
  );
}

// Menü stil ayarları
const menuLink = {
  color: "#fff",
  textDecoration: "none",
  fontSize: "18px",
  padding: "8px 0",
  transition: "color 0.2s",
  position: "relative",
};
const downIcon = { fontSize: "11px", marginLeft: "4px", verticalAlign: "middle" };

export default Header;
